import React, { useState } from "react";

import { Center, Grid, ScrollArea, Table, Text, createStyles, rem } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";

import NoteTypeTableRow from "../NoteTypeTableRow";
import NoteTypeModal from "../NoteTypeModal";
import { useSelector } from "react-redux";
import TableLoader from "../TableLoader";
import RecordNotFound from "../RecordNotFound";
import { Essential_Support_Note } from "../../http";

const useStyles = createStyles((theme) => ({
  header: {
    position: "sticky",
    top: 0,
    zIndex: 1,
    borderRadius: "16px",
    transition: "box-shadow 150ms ease",
    "& th": {
      backgroundColor: "#000",
      color: "#fff !important"
    },
    "&::after": {
      content: '""',
      position: "absolute",
      left: 0,
      right: 0,
      bottom: 0
    }
  },

  scrolled: {
    boxShadow: theme.shadows.sm
  },
  notFoundText: {
    color: "var(--app-text-muted)",
    fontFamily: "Inter",
    fontSize: "22px",
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "normal"
  }
}));

const NoteTypeTable = ({ data }) => {
  const { noteTypes, loading } = useSelector((state) => state.note);
  const [scrolled, setScrolled] = useState(false);
  const { classes, cx } = useStyles();
  const [selectedRow, setSelectedRow] = useState(null);
  const [isView, setIsView] = useState(false);
  const [opened, { open, close }] = useDisclosure(false);

  const handleView = (row) => {
    setSelectedRow(row);
    setIsView(true);
    open();
  };

  const handleEdit = (row) => {
    setSelectedRow(row);
    setIsView(false);
    open();
  };

  const handleClose = () => {
    close();
    setIsView(false);
    setSelectedRow(null);
  };

  // hide Essential Support Plan Type
  const filteredNoteTypes = noteTypes?.ntypes?.filter(
    (nt) => nt.id !== Essential_Support_Note
  );

  const rows = filteredNoteTypes?.map((row) => (
    <NoteTypeTableRow
      row={row}
      key={row.id}
      onView={handleView}
      onEdit={handleEdit}
    />
  ));
  return (
    <>
      {selectedRow && (
        <NoteTypeModal
          opened={opened}
          close={handleClose}
          title={"Edit Note Type"}
          data={selectedRow}
          view={isView}
          setView={setIsView}
        />
      )}
      <ScrollArea
        onScrollPositionChange={({ y }) => setScrolled(y !== 0)}
        sx={{ marginTop: "30px" }}
      >
        {loading ? (
          <TableLoader />
        ) : (
          <Table
            withColumnBorders
            withBorder
            highlightOnHover
            enableStickyHeader
            sx={{ fontFamily: "Inter" }}
            fontSize={"sm"}
            verticalSpacing={"md"}
          >
            <thead
              className={cx(classes.header, { [classes.scrolled]: scrolled })}
            >
              <tr>
                <th style={{ minWidth: "200px" }}>Note Type</th>
                <th style={{ minWidth: "140px" }}>Fields</th>
                <th style={{ minWidth: "140px" }}></th>
              </tr>
            </thead>
            <tbody>{rows}</tbody>
          </Table>
        )}
      </ScrollArea>
    </>
  );
};

export default NoteTypeTable;
